import type { StructureKind } from "../types/chain";

export const STRUCTURE_KINDS: StructureKind[] = [
  "Astrahus",
  "Fortizar",
  "Keepstar",
  "Athanor",
  "Tatara",
  "Raitaru",
  "Azbel",
  "Sotiyo",
  "POS",
  "other",
];
